export default __webpack_public_path__ + "static/media/ic-folder.2fafb115.svg";